$(document).ready(() => {
    if ($('.js_case-gallery').length) {
        $('.js_case-gallery').each((i,el) => {
            lightGallery(el, {
                plugins: [lgModules.thumbnail],
                speed: 500,
                selector: '.js_case-gallery__item',
                licenseKey: 'your_license_key',
                thumbnail: true,
                download: false,
            })
        })
    }
})